<ion-toolbar class="qvs-page-header__toolbar" [class.condense]="condense">
  <ng-content select="[start]"></ng-content>
  <ion-title *ngIf="title" class="qvs-page-header__toolbar__title" [class.condense]="condense">
    <h1>
      {{ title }}
    </h1>
  </ion-title>
  <ng-content select="[end]"></ng-content>
</ion-toolbar>
